import { useCallback } from 'react';
import Router from 'next/router';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

type TAction = 'simple' | 'long' | 'custom';

const actionMap: Record<TAction, string> = {
    simple: 'banner to req',
    long: 'marketing banner',
    custom: 'additionally banner to req',
};

export const useGaBanner = (type: TAction, title: string, link: string) => {
    const onDataLayerPush = useCallback((isFull: boolean) => {
        dataLayerPush({
            event: 'UAevent',
            category: 'banner main',
            action: `click ${title} ${actionMap[type]}${isFull ? ' full' : ''}`,
            label: link,
        });
    }, [title, link, type]);

    const onBannerClick = useCallback((isFull = false) => {
        onDataLayerPush(isFull);
        Router.push(link);
    }, [link, onDataLayerPush]);

    return { onBannerClick };
};
